import React, { useContext } from 'react';

export const PlayerContext = React.createContext({});
export const PlayerProvider = PlayerContext.Provider;
export const PlayerConsumer = PlayerContext.Consumer;

PlayerContext.displayName = 'PlayerContext';

export const usePlayer = () => useContext(PlayerContext);